import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import paths from '../../routes/paths'
import { verifyTable } from '../../actions/orderActions'
import { useHistory } from 'react-router-dom'
import { getFingerId } from '../../utils'

const VerifyTable = ({ match }) => {
    const { id, hash } = match.params
    const dispatch = useDispatch()
    const history = useHistory()

    const handleVerifyTable = async () => {
        const finger = await getFingerId();
        console.log({ finger });
        dispatch(
            verifyTable({
                params: {
                    id,
                    hash,
                    finger
                },
                onDone: res => {
                    if (res?.responseData?.data?.customerPosition !== undefined) {
                        history.push(paths.tableQRcodeSuccess)
                    } else {
                        history.push(paths.listFood)
                    }
                },
            })
        )
    }

    useEffect(() => {
        handleVerifyTable();
    }, [])

    return null
}

export default VerifyTable
